import React, { useCallback, useState } from 'react';
import { IBrushPoint } from '@meitu/saas-editor-core/es/version-types';
import { FillPointFeature } from '@/editor/panel/views/brush-panel/components/fill-point/fill-point';

const SelectPoint: React.FC<{
    defaultStartPoint: IBrushPoint;
    defaultEndPoint: IBrushPoint;
    dataSource: any;
    onComplete?: Function;
}> = React.memo(({ defaultStartPoint, defaultEndPoint, dataSource, onComplete }) => {
    const [startPoint, setStartPoint] = useState(defaultStartPoint);
    const [endPoint, setEndPoint] = useState(defaultEndPoint);

    const onPointChange = useCallback((trackCode, data) => {
        const { operate, url, type, offset, width, height } = data;
        const point = { url, type, offset, width, height };
        if (operate === 'left') {
            setStartPoint(point);
            dataSource.startPoint = point;
        } else if (operate === 'right') {
            setEndPoint(point);
            dataSource.endPoint = point;
        } else if (operate === 'swap') {
            const newStartPoint = { ...dataSource.endPoint };
            const newEndPoint = { ...dataSource.startPoint };

            setStartPoint(newStartPoint);
            dataSource.startPoint = newStartPoint;

            setEndPoint(newEndPoint);
            dataSource.endPoint = newEndPoint;
        }

        onComplete?.();
    }, []);

    return (
        <FillPointFeature
            startPoint={startPoint}
            endPoint={endPoint}
            onAfterChange={onPointChange}
            style={{ paddingTop: 12 }}
        />
    );
});

export default SelectPoint;
